<template>
    <div id="accreditation_voucher" class="container-content-data-qrcode">
        <ui-load-indicator v-if="load" bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />

        <svg v-if="deal" class="box-triangle" viewBox="0 0 1147 503" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 21L33 0L63 21L94 0L127 21L158 0L191 21L224 0L255 21L287.5 0L318 22L350 0L382.5 22L417.5 0L447.5 22L478.5 0L510.5 22L543 0L574 22L609 0L639 22L671.5 0L701 22L736 0L764.5 22L796.5 0L829 22L860.5 0L890.5 22L923 0L956.5 22L990 0L1020 21L1053 0L1083 22L1115.5 0L1146.5 21V482L1114.5 503L1083.5 483.5L1052.5 503L1020.5 483.5L989.5 503L956.5 483.5L922 503L892 483.5L860.5 503L828.5 483.5L796.5 503L766 483.5L733.5 503L704 483.5L670.5 503L639.5 483.5L611 503L575 483.5L541.5 503L510 483.5L478 503L447 483.5L416.5 503L383.5 483.5L350.5 503L319 483.5L288 502.5L255 483.5L224 502.5L191.5 482.5L158 503L127 483.5L95.5 502.5L64 482.5L32 502L0 482.5V21Z" fill="white"/>
        </svg>

        <div v-if="deal" class="content-data-qrcode">
            <div class="qrcode">
                <img :src="deal.qr_code" alt="Não foi possível carregar o QR Code" />
            </div>

            <div class="data-client">
                <div class="name-client">
                    {{ customer }}
                </div>

                <div v-if="deal?.owners?.broker" class="broker">
                    Corretor: {{ deal?.owners?.broker?.user?.first_name || '-' }}
                </div>

                <div v-else-if="deal?.owners?.manager" class="manager">
                    Gerente: {{ deal?.owners?.manager?.user?.first_name || '-' }}
                </div>

                <div v-if="deal?.owners?.team" class="team">
                    Equipe: {{ deal?.owners?.team?.name || '-' }}
                </div>

                <div class="indicator">
                    <div :class="{ 'is-approved-folder': isApprovedFolder }" class="square" />
                    {{ deal.id }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { uiLoadIndicator } from '@/components/ui'

    import { deal } from '@/services/axios'

    import { mapGetters } from 'vuex'

    export default {
        name: 'ui-accreditation-voucher',

        components: {
            uiLoadIndicator
        },

        props: {
            /**
             * Dados referentes ao negócio/cliente
             */
            data: {
                type: null,
                required: true
            }
        },

        data() {
            return {
                deal: null,
                load: false
            }
        },

        computed: {
            ...mapGetters('launchDay', {
                definitions: 'getDefinitions'
            }),
            /**
             * Computed property que define se o negócio mostrado está na etapa de Pasta Digital
             * e Status Aprovado
             */
            isApprovedFolder() {
                return this.deal &&
                    this.definitions &&
                    this.definitions.launchday &&
                    this.definitions.launchday.attributes &&
                    parseInt(this.deal.funnel_stage_id) === parseInt(this.definitions.launchday.attributes.saleStageDigitalFolder) &&
                    parseInt(this.deal.funnel_stage_status_id) === parseInt(this.definitions.launchday.attributes.saleStatusDigitalFolder)
            },
            /**
             * Computed property que define o nome do cliente vinculado ao negócio
             */
            customer() {
                let customer = '-'
                if (this.deal.customer) {
                    customer = this.deal.customer.name

                } else if (this.deal.customer_name) {
                    customer = this.deal.customer_name
                }

                return customer
            }
        },

        watch: {
            /**
             * Observa a prop data para buscar o novo QR Code sempre que o cliente/negócio
             * mudar
             */
            data(value) {
                if (!value) return

                this.loadQRCode()
            }
        },

        mounted() {
            if (this.data) this.loadQRCode()
        },

        methods: {
            /**
             * Carrega os dados do QR Code do negócio/cliente
             */
            loadQRCode() {
                this.$emit('loading', true)
                this.load = true
                // Busca os dados do QR Code referente ao cliente/negócio
                deal.getQRCode(this.data.id)
                    .then(response => {
                        this.deal = { ...this.data }
                        this.deal.qr_code = response.data
                    })
                    .catch(error => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.load = false
                        this.$emit('loading', false)
                    })
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>